module.exports = __webpack_public_path__ + "static/img/product-poster-2.b53911c0.png";